<template>
  <div class="base case">
    <inside-header title="课程安排" back-link-name="UserStudents" />
    <div class="note">
      <div>
        <a-empty v-if="list.length === 0 && !loading" />
      </div>
      <div v-for="item, index in list" :key="index" class="node">
        <div class="mode">
          <div class="left">
            {{ item.teaching_subject }}-{{ item.service_pack.title }}
          </div>
          <div class="right">
            {{ item.student.nick_name }}
          </div>
        </div>
        <div class="load">
          <span>授课时间</span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.data_info_str }}</span>
        </div>
        <a-row :gutter="8" class="play" type="flex" justify="space-between" align="bottom">
          <a-col v-for="scheduleItem, i in item.schedule" :key="i" :span="6">
            <a-button class="last" :disabled="scheduleItem.confirm_status" @click="confirmItemClass(scheduleItem.id)">
              {{ scheduleItem.date }}
            </a-button>
          </a-col>
        </a-row>
        <div class="wape">
          <span>具体时间</span>
          <span>自定</span>
        </div>
        <a-button class="pase" type="primary" :disabled="item.status === 'Complete'" @click="confirmClass(item.id)">
          授课确认
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'CourseArrangement',
  components: {
    InsideHeader
  },
  props: {
    student_id: {}
  },
  data() {
    return {
      loading: true,
      list: []
    }
  },
  created() {
    this.loadData(this.student_id)
  },
  methods: {
    loadData(id) {
      this.loading = true
      this.$http({
        url: 'index/user/courseArrange',
        method: 'get',
        params: {
          student_id: id
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          this.list = res.data.order_data
          console.log(res)
        }
      })
    },
    // 确认课程子项
    confirmItemClass(itemId) {
      this.$dialog.confirm({
        title: '确认',
        message: '当天课程已上？'
      })
        .then(() => {
          this.$http({
            url: 'index/user/confirmItemClass',
            method: 'post',
            data: {
              order_item_id: itemId
            }
          }).then(res => {
            if (res.status === 'success') {
              this.$toast.success(res.message)
              this.loadData()
            } else {
              this.$toast.fail(res.message)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 确认课程
    confirmClass(courseId) {
      this.$dialog.confirm({
        title: '注意',
        message: '确认后，资金将划入教员账户。请确认该课程已完成'
      }).then(() => {
        this.$http({
          url: 'index/user/confirmClass',
          method: 'post',
          data: {
            order_id: courseId
          }
        }).then(res => {
          if (res.status === 'success') {
            this.$toast.success(res.message)
            this.loadData()
          } else {
            this.$toast.fail(res.message)
          }
        })
      }).catch(() => {
        // on cancel
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
    .case {
        min-width: 280px;
        max-width: 420px;
        background-color: #fff;
        .note {
            padding: 15px;
            .node {
                padding: 30px 15px;
                box-shadow: 0 0 10px inset rgba(216,216,216,0.3);
                border-radius: 10px;
                .mode {
                overflow: hidden;
                    div:nth-child(1) {
                        float: left;
                        font-size: 16px;
                        color: #333333;
                    }
                    div:nth-child(2) {
                        float: right;
                        font-size: 16px;
                        color: #333333;
                    }
                }
                .load {
                    margin-top: 15px;
                }
                .play {
                    margin-top: 10px;
                    .last {
                        background-color: #eee;
                        text-align: center;
                        border-radius: 10px;
                        margin-bottom: 10px;
                    }
                }
                .btn {
                    .date {
                        background-color: #eee;
                        text-align: center;
                        padding: 2.5px;
                    }
                }
                .wape {
                    margin-top: 30px;
                    overflow: hidden;
                    span:first-child {
                        color: #333333;
                        font-size: 16px;
                        float: left;
                    }
                    span:nth-child(2) {
                        font-size: 16px;
                        color: #333333;
                        float: right;
                    }
                }
                .pase {
                    margin-top: 50px;
                    text-align:center;
                    // color: #fff;
                    font-size: 16px;
                    border-radius: 10px;
                    border: none;
                    // background-color: #ff5c00;
                    width: 100%;
                    height: 40px;
                }
            }
        }
    }
</style>
